import { render, staticRenderFns } from "./OzoneMail.vue?vue&type=template&id=439f43a6&"
import script from "./OzoneMail.vue?vue&type=script&lang=js&"
export * from "./OzoneMail.vue?vue&type=script&lang=js&"
import style0 from "./OzoneMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports